// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3dGMV","alertIcon":"ConfirmModal_alertIcon__3PgGr"};